import React from "react";
import Login from "./_/containers/Login";
import "./style.scss";

const LoginPage = props => <Login {...props} />;

export default LoginPage;